import { Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';
import { createElement, MouseEvent, MouseEventHandler } from 'react';

import { Consumer as HistoryConsumer } from '../../../context/history';

type Props = TypographyProps & {
  href: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  withNewTab?: boolean;
  className?: string;
};

const RouterLink = ({ href, withNewTab, onClick, className, ...otherProps }: Props) => (
  <HistoryConsumer>
    {(history) => (
      <Typography
        {...(otherProps as any)}
        component="a"
        href={href}
        target={withNewTab ? '_blank' : undefined}
        rel={withNewTab ? 'noopener' : undefined}
        onClick={(e: MouseEvent<HTMLElement>) => {
          if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
          if (href.startsWith('http')) return;

          e.preventDefault();

          history.push(href);

          if (onClick) onClick(e);
        }}
        className={className}
      />
    )}
  </HistoryConsumer>
);

export default RouterLink;
